import { render } from "./BaseCard.vue?vue&type=template&id=fde7d5d8&scoped=true"
import script from "./BaseCard.vue?vue&type=script&lang=js"
export * from "./BaseCard.vue?vue&type=script&lang=js"

import "./BaseCard.vue?vue&type=style&index=0&id=fde7d5d8&scoped=true&lang=css"

import exportComponent from "/Users/lopollo/projects/CVUE/CVUE-coaches/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fde7d5d8"]])

export default __exports__